/* Emițătorul interacțiunilor de pe COLECȚII și /search: filtre, sortare, pastilele de pachete.
 *
 * SURSA UNICĂ e acest fișier. Se copiază identic ca `assets/am-collection-tracking.js` în tema
 * DEV și se include din `theme.liquid`, după `am-nav-tracking.js`.
 *
 * DE CE (08.10.2026, cerut de Tudor): „vreau ca toate interacțiunile cu pachete și cu filtre să
 * fie tracked de GA4, ca să știm dacă modificările noastre aduc mai multe clickuri". Clicurile pe
 * produsele din grilă se măsurau deja (`am-list-tracking.js`, liste `collection:<id>`); filtrele,
 * sortarea și pastilele Toate/Boxe/Căști/Vinil nu se măsurau deloc.
 *
 * Publică UN eveniment prin `Shopify.analytics.publish`:
 *   colectie_interactiune — {tip, suprafata: "colectie" | "cautare", colectie_id?, filtru?, valoare}
 *     tip = pastila | filtru_adaugat | filtru_scos | filtre_resetate | sortare
 * Pixelul (`ascultator-pixel.js`) îl trimite în GA4 ca `am_colectie_interactiune`, prin proxy.
 *
 * FILTRELE SE CITESC DIN URL, NU DIN WIDGETURI. Măsurat pe tema live 07–08.10.2026:
 *   - filtrele native (Search & Discovery, `custom-async.js`): bifele fac `history.pushState` cu
 *     parametrii `filter.*`; „x"-ul de pe un filtru activ (`url_to_remove`) e un LINK care
 *     reîncarcă pagina;
 *   - panoul Typesense (`am-typesense-filters.js`): `pushState` cu `ts_<câmp>`; pe „Înapoi"
 *     (popstate) își reface starea din URL; la eșecul încărcării face `replaceState` pe URL-ul vechi.
 * Comparăm parametrii înainte/după fiecare `pushState`, fiecare navigare pe aceeași pagină (link
 * sau formular nepreluat de temă) și fiecare popstate (doar `ts.*`, și doar când filtrele native din
 * URL sunt cele afișate — tema n-are handler de popstate pentru ele). `replaceState` doar actualizează starea („Vezi mai multe",
 * rollback-ul Typesense — acolo bifa s-a numărat deja; limită acceptată, rară). O pagină deschisă
 * direct cu filtre în URL nu e o interacțiune și nu emite nimic.
 *
 * SORTAREA NU e în diferență: tema o schimbă prin `location.search` (reîncărcare) la `change` pe
 * `#sort_by`, iar fiecare bifă duce în URL și `sort_by=<implicită>` din `input.sort_by_clone` —
 * diferența de URL ar număra sortări false și le-ar rata pe cele reale (Codex, 08.10). Se citește
 * direct din `change`.
 * „ȘTERGE TOT" (`a.remove-all`) se numără explicit, cu numărul de filtre active, și absoarbe
 * tranziția spre zero filtre care urmează (fără eliminări individuale pentru aceeași acțiune).
 * PREȚUL se rotunjește la 500 lei (în jos minimul, în sus maximul); o mutare a sliderului = scos
 * vechea găleată + adăugat cea nouă, ca orice alt filtru.
 *
 * LIVRAREA E BEST-EFFORT, ca la meniu: același drum (pixel → proxy → GA4). Măsurarea nu are voie
 * să strice filtrarea: totul e în try/catch, iar funcțiile originale ale `history` se apelează
 * primele și își păstrează valoarea întoarsă.
 */
(function () {
  'use strict';

  if (window.__amColectieTracking) return;   // inclus de două ori = evenimente dublate
  window.__amColectieTracking = true;

  var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page;
  var tipPagina = meta && meta.pageType;
  if (tipPagina !== 'collection' && tipPagina !== 'searchresults') return;
  var suprafata = tipPagina === 'collection' ? 'colectie' : 'cautare';
  var colectieId = suprafata === 'colectie' && /^\d{1,20}$/.test(String(meta.resourceId || ''))
    ? String(meta.resourceId) : null;

  /* Alfabetul valorilor, identic cu proxy-ul (`RE_VALOARE_FILTRU`): litere/cifre Unicode și
   * punctuația etichetelor de filtre, inclusiv cea cu SENS din găleți Typesense (`33–199 Ω`,
   * `>92 dB`, `≤ 32 Ω`). Restul devine spațiu, ca proxy-ul să nu respingă tot evenimentul. */
  var NEPERMIS = /[^\p{L}\p{N} &\/.,'’"()+!:%°×<>≤≥–-]/gu;
  var MAX_VALOARE = 60;
  var MAX_EVENIMENTE = 5;   // o singură schimbare de URL nu are voie să inunde GA4
  var PAS_PRET = 500;
  var SORTARI = { 'manual': 1, 'best-selling': 1, 'title-ascending': 1, 'title-descending': 1,
    'price-ascending': 1, 'price-descending': 1, 'created-ascending': 1, 'created-descending': 1,
    'relevance': 1 };

  function valoare(t) {
    t = String(t || '');
    if (t.normalize) t = t.normalize('NFC');
    return t.replace(NEPERMIS, ' ').replace(/\s+/g, ' ').trim().slice(0, MAX_VALOARE).trim();
  }

  /* `filter.p.vendor` → `p.vendor`; `ts_putere` → `ts.putere`. Prefixul spune sistemul. */
  function cheie(k) {
    if (k.indexOf('filter.') === 0) return k.slice(7);
    if (k.indexOf('ts_') === 0) return 'ts.' + k.slice(3);
    return null;
  }

  function stare(search) {
    var q = new URLSearchParams(search || '');
    var perechi = {}, min = '', max = '';
    q.forEach(function (v, k) {
      if (k === 'filter.v.price.gte') { min = v; return; }
      if (k === 'filter.v.price.lte') { max = v; return; }
      var c = cheie(k);
      if (!c || v === '') return;
      perechi[c + '\u0000' + v] = { filtru: c, valoare: v };
    });
    return { perechi: perechi, pret: pret(min, max) };
  }

  function pret(min, max) {
    var a = parseFloat(min), b = parseFloat(max);
    var areMin = isFinite(a) && a > 0, areMax = isFinite(b) && b > 0;
    if (!areMin && !areMax) return '';
    var jos = areMin ? Math.floor(a / PAS_PRET) * PAS_PRET : 0;
    if (!areMax) return jos + '+';
    var sus = Math.ceil(b / PAS_PRET) * PAS_PRET;
    return sus > jos ? jos + '-' + sus : jos + '+';
  }

  /* `x`-ul de pe ultimul filtru duce la `?sort_by=manual` sau la URL gol — tot filtrare. */
  function doarParametriDeFiltrare(search) {
    var ok = true;
    new URLSearchParams(search || '').forEach(function (v, k) {
      if (!/^(filter\.|ts_)/.test(k) && k !== 'sort_by' && k !== 'q') ok = false;
    });
    return ok;
  }

  function nrActive(s) { return Object.keys(s.perechi).length + (s.pret ? 1 : 0); }

  function publica(d) {
    d.suprafata = suprafata;
    if (colectieId) d.colectie_id = colectieId;
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('audio_monkey:colectie_interactiune', d);
      }
    } catch (err) { /* măsurarea nu are voie să strice filtrarea */ }
  }

  /* Diferența dintre două stări, ca listă de evenimente. `doarTs`: doar filtrele Typesense. */
  function diferente(vechi, nou, doarTs) {
    var ev = [];
    function adauga(tip, p) {
      if (doarTs && p.filtru.indexOf('ts.') !== 0) return;
      var v = valoare(p.valoare);
      if (v) ev.push({ tip: tip, filtru: p.filtru, valoare: v });
    }
    Object.keys(vechi.perechi).forEach(function (k) { if (!nou.perechi[k]) adauga('filtru_scos', vechi.perechi[k]); });
    Object.keys(nou.perechi).forEach(function (k) { if (!vechi.perechi[k]) adauga('filtru_adaugat', nou.perechi[k]); });
    if (!doarTs && nou.pret !== vechi.pret) {
      if (vechi.pret) ev.push({ tip: 'filtru_scos', filtru: 'pret', valoare: vechi.pret });
      if (nou.pret) ev.push({ tip: 'filtru_adaugat', filtru: 'pret', valoare: nou.pret });
    }
    return ev.slice(0, MAX_EVENIMENTE);
  }

  var curenta = stare(location.search);
  /* După „Șterge tot" așteptăm EXACT o tranziție spre zero filtre (AJAX sau reîncărcare) și o
   * absorbim fără evenimente individuale. Nu fereastră de timp (Codex, runda 2): o bifă făcută
   * imediat după s-ar fi pierdut, iar o resetare lentă ar fi fost numărată de două ori.
   * O altă acțiune PE FILTRE (link spre aceeași pagină, `change` pe un câmp de filtru/sortare,
   * popstate) dezarmează așteptarea: dacă cererea temei pentru resetare a eșuat, următorul „x" pe
   * ultimul filtru e tot o tranziție spre zero, dar e a lui (Codex, runda 3). Un clic oarecare
   * (acordeonul unui grup, un card) NU dezarmează: resetarea poate fi încă în zbor (runda 4). */
  var resetAsteptat = false;

  function actualizeaza(search, emite) {
    try {
      var noua = stare(search);
      if (resetAsteptat && nrActive(noua) === 0) { resetAsteptat = false; emite = false; }
      else if (resetAsteptat && emite) resetAsteptat = false;   // altă tranziție: resetarea n-a venit
      if (emite) diferente(curenta, noua, false).forEach(publica);
      curenta = noua;
    } catch (err) { /* idem */ }
  }

  /* Semnătura filtrelor NATIVE (fără `ts.*`), ca să știm dacă un popstate le-ar schimba. */
  function semnaturaNativa(s) {
    return Object.keys(s.perechi).filter(function (k) { return k.indexOf('ts.') !== 0; }).sort().join('\u0001') +
      '\u0002' + s.pret;
  }

  /* „Înapoi"/„Înainte": DOAR panoul Typesense își reface starea din URL, și numai dacă filtrele
   * native din URL sunt cele afișate (altfel nici el nu reacționează). Tema n-are handler de
   * popstate pentru filtrele native, deci un pas de istoric care le schimbă lasă pagina neschimbată
   * — atunci nici noi nu schimbăm starea cunoscută (Codex, runda 2: altfel „x"-ul vizibil de pe
   * un filtru nativ nu mai producea `filtru_scos`). */
  function laPopstate() {
    resetAsteptat = false;
    try {
      var noua = stare(location.search);
      if (semnaturaNativa(noua) !== semnaturaNativa(curenta)) return;
      diferente(curenta, noua, true).forEach(publica);
      curenta = noua;
    } catch (err) { /* idem */ }
  }

  ['pushState', 'replaceState'].forEach(function (metoda) {
    var original = history[metoda];
    if (typeof original !== 'function') return;
    history[metoda] = function () {
      var rezultat = original.apply(this, arguments);
      actualizeaza(location.search, metoda === 'pushState');
      return rezultat;
    };
  });
  window.addEventListener('popstate', laPopstate);

  window.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var esteReset = !!e.target.closest('a.remove-all');
    /* Pastilele Toate/Boxe/Căști/Vinil (`sections/am-pachete-promo-nav.liquid`). Valoarea e
     * handle-ul țintei, identic pe piețe; eticheta randată ar fi în bulgară pe .bg. */
    var pastila = e.target.closest('a.am-pp-nav__pill[href]');
    if (pastila) {
      var handle = (pastila.pathname || '').split('/').filter(Boolean).pop() || '';
      if (/^[a-z0-9-]{1,60}$/.test(handle)) publica({ tip: 'pastila', valoare: handle });
      return;
    }
    /* „Șterge tot" — numărat o dată, oricum l-ar executa tema (link sau AJAX). */
    if (esteReset) {
      var n = nrActive(curenta);
      if (n > 0) publica({ tip: 'filtre_resetate', valoare: String(Math.min(n, 99)) });
      resetAsteptat = true;
      return;
    }
    /* Navigare completă pe aceeași pagină („x"-ul de pe filtrul activ). Faza de bubble pe
     * `window` + `defaultPrevented`: dacă tema a preluat clicul prin AJAX, emite pushState-ul,
     * deci nu se numără de două ori. */
    /* Link de FILTRU = în tabul curent, pe aceeași pagină, și schimbă filtrele. Nu: `#filter`
     * (deschide sertarul pe mobil), paginarea/vederea (aceleași filtre), `target` ≠ `_self`,
     * clic cu Ctrl/Cmd/Shift/Alt sau buton din mijloc (navigarea e în alt tab) — Codex, runda 5;
     * linkurile de vedere `?view=grid|list` (fără filtre, tema le preia și schimbă doar aspectul)
     * — runda 6. Regula: query-ul linkului conține DOAR parametri de filtrare. */
    var a = e.target.closest('a[href]');
    if (!a || a.host !== location.host || a.pathname !== location.pathname) return;
    if ((a.getAttribute('href') || '').charAt(0) === '#') return;
    if (a.target && a.target !== '_self') return;
    if (e.button || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    if (!doarParametriDeFiltrare(a.search)) return;
    var ev = diferente(curenta, stare(a.search), false);
    if (!ev.length) return;
    resetAsteptat = false;   // tranziția care urmează e a acestui link
    if (e.defaultPrevented) return;   // preluat de temă prin AJAX: emite pushState-ul
    ev.forEach(publica);
    curenta = stare(a.search);
  });

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || (f.method || '').toLowerCase() !== 'get') return;
    try {
      var tinta = new URL(f.action || location.href, location.href);
      if (tinta.host !== location.host || tinta.pathname !== location.pathname) return;
      actualizeaza('?' + new URLSearchParams(new FormData(f)).toString(), true);
    } catch (err) { /* idem */ }
  });

  /* Sortarea: `change` pe selectul temei. Comparăm cu sortarea de la încărcare (din URL sau din
   * câmpul temei); pagina se reîncarcă imediat după, deci nu e nevoie de altă stare.
   * Valoarea se citește într-un `setTimeout(0)`: dropdown-ul temei (semantic select) emite
   * `change` (fără bubble) ÎNAINTE să schimbe valoarea selectului — măsurat pe DEV 08.10:
   * sincron = sortarea veche, după 0 ms = cea nouă. Tema însăși citește tot într-un setTimeout.
   * Ascultătorul în faza de captură prinde și evenimentul fără bubble, iar timerul lui e pus
   * în coadă înaintea celui al temei, deci rulează înainte de reîncărcare. */
  var sortInitial = '';
  try {
    var campSort = document.querySelector('select[name="sort_by"]');
    sortInitial = new URLSearchParams(location.search).get('sort_by') || (campSort && campSort.value) || '';
  } catch (err) { /* idem */ }
  document.addEventListener('change', function (e) {
    var el = e.target;
    // o bifă/sortare după „Șterge tot" e acțiunea ei, nu resetarea
    if (el && (/^(filter\.|sort_by$)/.test(el.name || '') || /^Filter-ts-/.test(el.id || ''))) resetAsteptat = false;
    if (!el || el.name !== 'sort_by' || el.tagName !== 'SELECT') return;
    setTimeout(function () {
      if (el.value !== sortInitial && SORTARI[el.value]) {
        publica({ tip: 'sortare', valoare: el.value });
        sortInitial = el.value;
      }
    }, 0);
  }, true);
})();
